import { NotificationQueue } from './notification-queue';
import { CookieHandler } from '../cookie';
import { NotificationData, NonEsalesNotificationData } from './types';
import { Payment, PaymentSettings } from './payment';
import { validate, validateTicket } from './notification-validation';

export class Notification {
  constructor(
    private baseURL: string,
    private market: string,
    private queue: NotificationQueue,
    private cookies: CookieHandler) { }

  private generateId(): string { return Math.random().toString(36); }

  click(ticket: string): void {
    validateTicket(ticket);
    this.queue.add({
      id: this.generateId(),
      url: this.baseURL + '/notifications/click',
      sessionKey: this.cookies.sessionKey(),
      customerKey: this.cookies.customerKey(),
      market: this.market,
      ticket
    } as NotificationData);
  }

  nonEsalesClick(data: NonEsalesNotificationData): void {
    validate(data);
    this.queue.add({
      id: this.generateId(),
      url: this.baseURL + '/notifications/non-esales-click',
      sessionKey: this.cookies.sessionKey(),
      customerKey: this.cookies.customerKey(),
      market: this.market,
      productKey: data.productKey,
      variantKey: data.variantKey
    } as NotificationData);
  }

  addToCart(ticket: string): void {
    validateTicket(ticket);
    this.queue.add({
      id: this.generateId(),
      url: this.baseURL + '/notifications/adding-to-cart',
      sessionKey: this.cookies.sessionKey(),
      customerKey: this.cookies.customerKey(),
      market: this.market,
      ticket
    } as NotificationData);
  }

  nonEsalesAddToCart(data: NonEsalesNotificationData): void {
    validate(data);
    this.queue.add({
      id: this.generateId(),
      url: this.baseURL + '/notifications/non-esales-adding-to-cart',
      sessionKey: this.cookies.sessionKey(),
      customerKey: this.cookies.customerKey(),
      market: this.market,
      productKey: data.productKey,
      variantKey: data.variantKey
    } as NotificationData);
  }

  payment(): Payment {
    return new Payment({
      id: this.generateId(),
      url: this.baseURL + '/notifications/payment',
      sessionKey: this.cookies.sessionKey(),
      customerKey: this.cookies.customerKey(),
      market: this.market
    } as PaymentSettings,
    this.queue);
  }

  end(): void {
    this.queue.add({
      id: this.generateId(),
      url: this.baseURL + '/notifications/end',
      sessionKey: this.cookies.sessionKey(),
      customerKey: this.cookies.customerKey(),
      market: this.market
    } as NotificationData);

    this.cookies.sessionKey(this.cookies.uuid());
    this.cookies.customerKey(this.cookies.uuid());
  }
}
